// LuckyDrawWindow.js
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Confetti from "react-confetti";

function trekkGyldigTall(fraTall, tilTall, utelukkListe) {
    let nummer;
    do {
        nummer = Math.floor(Math.random() * (tilTall - fraTall + 1)) + fraTall;
    } while (utelukkListe.includes(nummer));
    return nummer;
}

function LuckyDrawWindow() {
    const location = useLocation();
    const { fraTall, tilTall, utelukkListe } = location.state ?? {
        fraTall: 1,
        tilTall: 100,
        utelukkListe: []
    };
    

    const [nummer, setNummer] = useState(null);
    const [snurrer, setSnurrer] = useState(false);
    const [vinner, setVinner] = useState(false);

    useEffect(() => {
        document.title = "Lucky Draw";
    }, []);

    const startTrekning = () => {
        setSnurrer(true);
        setVinner(false);

        let teller = 0;
        const interval = setInterval(() => {
            setNummer(Math.floor(Math.random() * (tilTall - fraTall + 1)) + fraTall);
            teller++;

            if (teller > 40) {
                clearInterval(interval);
                const vinnerTall = trekkGyldigTall(fraTall, tilTall, utelukkListe);
                setNummer(vinnerTall);
                setSnurrer(false);
                setVinner(true);
            }
        }, 100);
    };

    return (
        <div className="flex flex-col justify-center items-center h-screen bg-blue-500 text-white">
            {vinner && <Confetti />}
            <div className="bg-white text-black rounded-lg p-6 text-center shadow-lg w-80">
                <h1 className="text-2xl font-bold">Trekning!</h1>
                <div className="text-5xl font-bold my-4">{nummer || "🎲"}</div>
                <button
                    onClick={startTrekning}
                    disabled={snurrer}
                    className="px-6 py-3 bg-green-500 text-white text-xl font-bold rounded-lg shadow-md hover:bg-green-600 transition duration-300 disabled:bg-gray-500"
                >
                    Start trekning
                </button>
            </div>
        </div>
    );
}

export default LuckyDrawWindow;
